import { BaseEntity } from '@base-entities';
import { IBaseTransformerRepository } from '@base-repositories';

import { LogTransformer } from '../transformers';

export function makeLogTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new LogTransformer<E>();
}
